import { GroupAddComponent } from './group-add.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PatientPipesModule } from '../../patient/pipes/patient-pipes.module';
import { TranslateModule } from '../../../shared/translate/translate.module';

@NgModule({
  declarations: [GroupAddComponent],
  imports: [
    PatientPipesModule,
    CommonModule, IonicModule, FormsModule, ReactiveFormsModule, TranslateModule
  ],
  exports: [GroupAddComponent]
})
export class GroupAddModule { }
